var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import axios from 'axios';
import * as R from 'ramda';
import { defaultApiConfig } from '../../config';
export var createHttpClient = function (apiConfig, handlers) {
    var httpClient = axios.create(__assign(__assign({}, defaultApiConfig), apiConfig));
    httpClient.interceptors.request.use(R.path(['requestHandler'], handlers) ? handlers.requestHandler : function (request) { return Promise.resolve(request); }, function (error) { return Promise.reject(error); });
    httpClient.interceptors.response.use(R.path(['responseHandler'], handlers) ? handlers.responseHandler : function (response) { return Promise.resolve(response); }, R.path(['errorHandler'], handlers) ? handlers.errorHandler : function (error) { return Promise.reject(error); });
    return httpClient;
};
//# sourceMappingURL=http-client.js.map